// Motion from the HTML tokens. ease = cubic-bezier(.2,.8,.2,1); durations match
// the prototype's transitions (toggles .16s, drawers .24s, modal rise .22s, fades .2s).
export const Motion = {
  fast:   160, // toggles / hovers
  base:   220, // modal rise, fades
  slow:   240, // drawer slide-in
  easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
};
